import { Radio, RadioGroup } from '@ps/isp-web-component-library';
import { useTrackers } from '@ps/web-shared-analytics';
import { Translation, useTrackingLabel } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { select } from '@swf/core/store';
import useAutoAcceptPriceChanges from '@swf/sports/hooks/useAutoAcceptPriceChanges';

import {
  TXTCLI_No,
  TXTCLI_Yes,
  TXTWCL_Automatically_accept_price_cha_ELL
} from './AutoAcceptPriceSelector.messages.json';

const SportsAutoAcceptPriceSelector: React.FC = () => {
  const hasAutoAcceptEnabled = useSelector(select.account.hasAutoAcceptEnabled);
  const { setAutoAcceptPriceChanges } = useAutoAcceptPriceChanges();
  const { formatMessage } = useRegulatoryIntl();
  const { inputFilled } = useTrackers();
  const autoAcceptTrackingLabel = useTrackingLabel(TXTWCL_Automatically_accept_price_cha_ELL);

  const handleOnChange = async (value: string) => {
    const autoAcceptPriceChanges = value === 'yes';

    await setAutoAcceptPriceChanges({ autoAcceptPriceChanges });
    inputFilled({
      fieldName: autoAcceptTrackingLabel,
      fieldType: 'radio',
      boolInput: autoAcceptPriceChanges
    });
  };

  const selectedValue = hasAutoAcceptEnabled ? 'yes' : 'no';

  return (
    <RadioGroup
      orientation="horizontal"
      onChange={handleOnChange}
      value={selectedValue}
      aria-label={formatMessage(TXTWCL_Automatically_accept_price_cha_ELL)}
    >
      <Radio value="no">
        <Translation {...TXTCLI_No} />
      </Radio>
      <Radio value="yes">
        <Translation {...TXTCLI_Yes} />
      </Radio>
    </RadioGroup>
  );
};

export default SportsAutoAcceptPriceSelector;
